import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Mode } from '../models/commonEnums';
import { Store } from '../reducers';
import styles from './BackButton.module.scss';
import MaterialIcon from './MaterialIcon';
import { Header1 } from './ViewWrapper';

type StateProps = {
    mode: Mode;
};
type ParentProps = {
    headerText?: string;
};

type Props = ParentProps & StateProps;
const BackButton = ({ headerText, mode }: Props): JSX.Element => {
    const navigate = useNavigate();

    if (mode === Mode.b2c_mobile) {
        if (headerText) return <Header1>{headerText}</Header1>;
        return <div />;
    }

    return (
        <div className={styles.buttonWrapper}>
            <button
                type="button"
                className={styles.button}
                onClick={(): void => navigate(-1)}
                {...{ ['data-go-back-button']: true }}
            >
                <MaterialIcon name="chevron_left" />
            </button>
            {headerText && <Header1>{headerText}</Header1>}
            {headerText && <div className={styles.placeholder} />}
        </div>
    );
};

const mapStateToProps = (state: Store): StateProps => {
    const {
        user: { mode },
    } = state;
    return {
        mode,
    };
};

export default connect(mapStateToProps)(BackButton);
